import React from "react";
import { ArrowRightShort } from "react-bootstrap-icons";
import axios from "axios";
import ProductCard from "../common/ProductCard";
import CardSkeleton from "../common/CardSkeleton";
import { useQuery } from "react-query";

const FeaturedProducts = React.memo(function FeaturedProducts() {
  const { data, isLoading } = useQuery({
    queryKey: ["featuredProducts"],
    queryFn: async () => {
      const options = {
        method: "GET",
        url: process.env.REACT_APP_BASE_URL + "/api/products",
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
        params: {
          list: "featured",
        },
      };

      const response = await axios.request(options);
      return response.data.data;
    },
  });

  function goToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  /* console.log(data) */
  return (
    <div className="container">
      <div className="inner-content">
        <div className="row rooms-for-rent">
          <div className="col-12 text-center">
            <h3 className="store-title">Store</h3>
            <p className="store-subtitle">Discover exclusive products you won't find anywhere else, only at Sahi Search.</p>
          </div>
          {isLoading
            ? // Show 3 skeleton cards while loading
              Array.from({ length: 3 }).map((_, index) => (
                <div className="col-lg-4 col-md-6 col-sm-6 card-holder" key={`skeleton-${index}`}>
                  <CardSkeleton />
                </div>
              ))
            : data &&
              data.map((element, index) => {
                return (
                  <div className="col-lg-4 col-md-6 col-sm-6 card-holder" key={index}>
                    <ProductCard product={element} goToTop={goToTop} />
                  </div>
                );
              })}
          <div className="row text-center">
            <a onClick={goToTop} href={`${process.env.REACT_APP_STORE_URL}`} className="show-more text-decoration-none">
              Show more <ArrowRightShort size="25" style={{ color: "#475467" }} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
});

export default FeaturedProducts;
